import { render, staticRenderFns } from "./BannerAnimado.vue?vue&type=template&id=fc725e24&scoped=true"
import script from "./BannerAnimado.vue?vue&type=script&lang=js"
export * from "./BannerAnimado.vue?vue&type=script&lang=js"
import style0 from "./BannerAnimado.vue?vue&type=style&index=0&id=fc725e24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc725e24",
  null
  
)

export default component.exports